import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import RoutesConstants from '../routes/routes-constants';
import PageHead from './page-head';

type RouteHeadConfig = {
  path: string;
  titleId: string;
  descriptionId?: string;
};

const routeHeadConfigs: RouteHeadConfig[] = [
  {
    path: RoutesConstants.AIMSPortal,
    titleId: 'aims_title',
    descriptionId: 'aims_title',
  },
  {
    path: RoutesConstants.HolidayCalendar,
    titleId: 'factory_schedule_title',
    descriptionId: 'factory_schedule_title',
  },
  {
    path: RoutesConstants.FactorySchedule,
    titleId: 'factory_schedule_title',
    descriptionId: 'factory_schedule_title',
  },
  {
    path: RoutesConstants.ProductManagement,
    titleId: 'product_title',
    descriptionId: 'product_title',
  },
  {
    path: RoutesConstants.ProcessTemplateManagement,
    titleId: 'process_template_title',
    descriptionId: 'process_template_title',
  },
  {
    path: RoutesConstants.TeplarPrintTemplateManagement,
    titleId: 'teplar_print_title',
    descriptionId: 'teplar_print_title',
  },
  {
    path: RoutesConstants.TrayManagement,
    titleId: 'tray_management',
    descriptionId: 'tray_management',
  },
  {
    path: RoutesConstants.GroupManagement,
    titleId: 'group_management',
    descriptionId: 'group_management',
  },
  {
    path: RoutesConstants.UserLogs,
    titleId: 'user_logs',
    descriptionId: 'user_logs',
  },
  {
    path: RoutesConstants.DimensionTableFields,
    titleId: 'dimension_table_fields',
    descriptionId: 'dimension_table_fields',
  },
  {
    path: RoutesConstants.CheckItemTemplate,
    titleId: 'check_item_template',
    descriptionId: 'check_item_template',
  },
  {
    path: RoutesConstants.TrayTagReassignment,
    titleId: 'tray_tag_reassignment_title',
    descriptionId: 'tray_tag_reassignment_title',
  },
  {
    path: RoutesConstants.ActiveTrayManagement,
    titleId: 'active_tray_management',
    descriptionId: 'active_tray_management',
  },
  {
    path: RoutesConstants.ProcessManagement,
    titleId: 'process_title',
    descriptionId: 'process_title',
  },
    {
    path: RoutesConstants.OperatorListDetail,
    titleId: 'operator_tasks',
    descriptionId: 'operator_tasks',
  },
    {
    path: RoutesConstants.OperatorAssignTask,
    titleId: 'operator_assign_task',
    descriptionId: 'operator_assign_task',
  },
  {
    path: RoutesConstants.OrderTableView,
    titleId: 'order_table',
    descriptionId: 'order_table',
  },
  {
    path: RoutesConstants.HKRDashboarData,
    titleId: 'hkr_schedule',
    descriptionId: 'hkr_schedule',
  },
  {
    path: RoutesConstants.BomSearch,
    titleId: 'bom_search',
    descriptionId: 'bom_search',
  },
  {
    path: RoutesConstants.UserManagement,
    titleId: 'system_user',
    descriptionId: 'system_user',
  },
  {
    path: RoutesConstants.KishuManagement,
    titleId: 'kishu_title',
    descriptionId: 'kishu_title',
  },
  {
    path: RoutesConstants.FactoryManagement,
    titleId: 'factory_management',
    descriptionId: 'factory_management',
  },
  {
    path: RoutesConstants.FactoryAccess,
    titleId: 'factory_access',
    descriptionId: 'factory_access',
  },
  {
    path: RoutesConstants.MaterialTagAssign,
    titleId: 'material_tag_assign',
    descriptionId: 'material_tag_assign',
  },
  {
    path: RoutesConstants.PartsSearch,
    titleId: 'parts_search',
    descriptionId: 'parts_search',
  },
  {
    path: RoutesConstants.ProcessWiseChart,
    titleId: 'process_wise_chart',
    descriptionId: 'process_wise_chart',
  },
];

const RoutePageHead = () => {
  const location = useLocation();
  const routeConfig = routeHeadConfigs.find((config) => {
    return matchPath(location.pathname, { path: config.path, exact: true }) !== null;
  });

  const searchParams = new URLSearchParams(location.search);
  const processName = searchParams.get('processName');
  const processType = searchParams.get('processType');

  return (
    <PageHead
      title={processName || undefined}
      titleId={!processName ? routeConfig?.titleId : undefined}
      description={processType || undefined}
      descriptionId={!processType ? routeConfig?.descriptionId : undefined}
    />
  );
};

export default RoutePageHead;
